import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'numToDate'
})
export class NumToDatePipe implements PipeTransform {

  transform(value: number, args?: any): any {
    if (value > 0 && value < 30) {
      return value + ' Day' + (value === 1 ? '' : 's');
    } else if (value >= 30 && value < 365) {
      return Math.floor(value / 30) + ' Month' + (Math.floor(value / 30) === 1 ? '' : 's') + ' (' + value + ' days)';
    } else if (value >= 365) {
      return Math.floor(value / 365) + ' Year' + (Math.floor(value / 365) === 1 ? '' : 's') + ' (' + value + ' days)';
    } else if (value === 0) {
      return '--';
    }
  }

}
